import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaRegEdit, FaSearch, FaFilter, FaEraser } from "react-icons/fa";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import api from "../../services/api";
import { idiomaAtual } from '../../i18n';
import { hasPerm } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import { formataDataExibicao, formataDataHoraExibicao, getCurrentUser, formataCNPJ } from '../../common/utils';
import { formatarMoeda } from '../../i18n/format';

class Faturamentos extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.carregaProgramasDelay = this.delayCamposAsync(this.carregaProgramas.bind(this), 3000);
        this.carregaPrestadoresDelay = this.delayCamposAsync(this.carregaPrestadores.bind(this), 3000);

        this.state = {
            listRegistros: [],
            error: "", 
            busca: "",
            page_numb: 1,
            loading: true,
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_prestador_id: '',
            filtro_prestador_nome: '',
            filtro_categoria_prestador_id: '',
            filtro_categoria_prestador_nome: '',
            filtro_pago: '',
            filtro_status_nf: '',
            prestador_select_key: 0,
            filtro_cancelado: '',
            filtro_numero_nf: '',
            filtro_id_faturamento: '',
            filtro_servico_id: '',
            filtro_servico_nome: '',
            servico_select_key: 0,
            tipo_usuario: '',
            ambiente_programa_id: '',
            filtro_categoria_prestador: '',
            programasOptions: [],
            loadingProgramas: false,
            prestadoresOptions: [],
            loadingPrestadores: false,
        };

        this.categoriasPrestador = {
            "medicos": "Médicos",
            "multiprofissionais": "Multiprofissionais", 
            "farmacias": "Farmácias",
            "hospitais": "Hospitais",
            "clinicas": "Clinicas",
            "plataformas": "Plataformas",
            "servicos_diagnostico": "Serviços Diagnóstico",
            "laboratorio_diagnostico": "Laboratório Diagnóstico",
            "cooperativas_saude": "Cooperativas de Saúde",
            "motoristas": "Transporte",
            "logistica": "Logística",
            "outros": "Outros"
        };
    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        let ambiente_programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : '';
        this.setState({
            ambiente_programa_id: ambiente_programa_id
        }, () => {
            this.carregaProgramas("")
            this.carregaPrestadores("")
            this.consultaRegistros()
        })
    }

    consultaRegistros(){
        let dados_usuario = getCurrentUser();
        const programa_id = this.state.ambiente_programa_id ? this.state.ambiente_programa_id : this.state.filtro_programa_id;

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario
        })

        let filtros = `?page=${this.state.page_numb}&tipo_usuario=${dados_usuario.tipo_usuario}`

        if(this.state.filtro_data_inicio){
            filtros += '&data_inicio='+this.state.filtro_data_inicio
        }

        if(this.state.filtro_data_fim){
            filtros += '&data_fim='+this.state.filtro_data_fim
        }

        if(programa_id){
            filtros += `&programa_id=${programa_id}`
        }

        if(this.state.filtro_prestador_id){
            filtros += `&laboratorio_id=${this.state.filtro_prestador_id}`
        }

        if(this.state.filtro_pago){
            filtros += '&pago='+this.state.filtro_pago
        }

        if(this.state.filtro_status_nf){
            filtros += '&nota_fiscal_status='+this.state.filtro_status_nf
        }

        if(this.state.filtro_categoria_prestador){
            filtros += '&categoria='+this.state.filtro_categoria_prestador
        }

        if(this.state.filtro_cancelado){
            filtros += '&cancelado='+this.state.filtro_cancelado
        }

        if(this.state.filtro_numero_nf){
            filtros += '&nota_fiscal_numero='+this.state.filtro_numero_nf
        }

        if(this.state.filtro_id_faturamento){
            filtros += '&id='+this.state.filtro_id_faturamento
        }

        if(this.state.filtro_servico_id){
            filtros += '&servico_procedimento_id='+this.state.filtro_servico_id
        }

        api.get(`/faturamento/${filtros}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            // guarda a chave; a mensagem é traduzida no render
            let erro_msg = 'faturamentos:lista.errors.load';

            if(error.response.status === 500){
                erro_msg = 'faturamentos:errors.server';
            }
            else if(error.response.status === 403){
                erro_msg = 'faturamentos:errors.forbidden';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label,  
                filtro_prestador_id: '',
                filtro_prestador_nome: ''
            }, () => {
                //this.carregaPrestadores("", true)
            });
        }
        else if(fieldName == 'prestador_id') {
            this.setState({ 
                filtro_prestador_id: event.value, 
                filtro_prestador_nome: event.label, 
            });
        } else if(fieldName == 'filtro_categoria_prestador') {
            const { value } = event.target;
            const label = event.target.options[event.target.selectedIndex].text;
            this.setState(prevState => ({
                filtro_categoria_prestador: value,
                filtro_categoria_prestador_id: value,
                filtro_categoria_prestador_nome: label,
                filtro_prestador_id: "", 
                filtro_prestador_nome: "", 
                prestador_select_key: prevState.prestador_select_key + 1 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    delayCamposAsync = (fn, delay = 3000) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            return new Promise((resolve) => {
            timeout = setTimeout(async () => {
                try {
                const res = await fn(...args);
                resolve(res);
                } catch (e) {
                resolve([]); 
                }
            }, delay);
            });
        };
    };

    handleChangeFiltrosPagamento = (event) => {
        const { name, value } = event.target;
        console.error(`Campo alterado: ${name}, Valor: ${value}`);
    
        this.setState({ [name]: value }, () => {
            this.consultaRegistros(); 
        });
    };

    carregaProgramas = async (inputValue = "") => {
        try {
            if (!inputValue) {
                this.setState({ loadingProgramas: true });
            }
            let response;

            if (this.state.ambiente_programa_id) {
                response = await api.get(`/programas/?programa_id=${this.state.ambiente_programa_id}`);
            } else {
                response = await api.get(`/programas/?nome=${inputValue}`);
            }

            const opcoes = response.data.results.map(programa => {
                if (programa.id === parseInt(this.state.ambiente_programa_id)) {
                    this.setState({
                        filtro_programa_id: programa.id,
                        filtro_programa_nome: programa.nome
                    });
                }
                return {
                    value: programa.id,
                    label: programa.nome
                };
            });

            if (!inputValue) {
                this.setState({
                    programasOptions: opcoes,
                    loadingProgramas: false
                });
            }
            return opcoes;

        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            if (!inputValue) {
                this.setState({ loadingProgramas: false });
            }
            return [];
        }
    };

    carregaPrestadores = async (inputValue = "") => {
        const programa_id = this.state.ambiente_programa_id ? this.state.ambiente_programa_id : this.state.filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            if (!inputValue) {
                this.setState({ loadingPrestadores: true });
            }

            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&programa_id=${programa_id}&categoria=${this.state.filtro_categoria_prestador_id}`);

            const opcoes = response.data.results.map(prestador => {
                const localizacao = [prestador.bairro, prestador.cidade]
                    .filter(Boolean)
                    .join(", ");

                return {
                    value: prestador.id,
                    label: `${prestador.nome} (${prestador.cpf_cnpj}${localizacao ? " - " + localizacao : ""})`
                };
            });

            if (!inputValue) {
                this.setState({
                    prestadoresOptions: opcoes,
                    loadingPrestadores: false
                });
            }
            return opcoes;

        } catch (error) {
            console.error("Erro ao carregar prestadores:", error);
            if (!inputValue) {
                this.setState({ loadingPrestadores: false });
            }
            return [];
        }
    };

    // Serviços do programa selecionado, para filtrar o faturamento por serviço.
    carregaServicos = async (inputValue = "") => {
        const programa_id = this.state.ambiente_programa_id ? this.state.ambiente_programa_id : this.state.filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            const response = await api.get(
                `/programas/servicos_procedimentos/?servico_procedimento=${inputValue}&status=1&programa=${programa_id}&limit=100`
            );

            return (response.data.results || [])
                .filter(item => item.servico_procedimento_id > 0)
                .map(item => ({
                    value: item.servico_procedimento_id,
                    label: item.dados_servico?.nome || ''
                }));
        } catch (error) {
            console.error("Erro ao carregar serviços:", error);
            return [];
        }
    };


    getLabelNotaFiscal = (nota, nota_fiscal_status) => {
        let style_options = {
            backgroundColor: '#3cc172',
            color: '#ffffff',
            padding: '5px 10px',
            fontSize: '12px',
            borderRadius: '5px',
            display: 'inline-block',
        }
        let texto = 'aprovado'

        if(!nota){
            texto = 'pendente'
            style_options['backgroundColor'] = 'orange'
            style_options['color'] = '#fff'
        }
        else if(nota_fiscal_status == 'analise'){
            texto = 'analise'
            style_options['backgroundColor'] = '#f2f2f2'
            style_options['color'] = '#252f4a'
        }
        else if(nota_fiscal_status == 'recusado'){
            texto = 'recusado'
            style_options['backgroundColor'] = '#eb4961'
            style_options['color'] = '#fff'
        } else if(nota_fiscal_status == 'cancelado'){
            texto = 'cancelado'
            style_options['backgroundColor'] = '#eb4961'
            style_options['color'] = '#fff'
        }

        return <span style={style_options}>
            {this.props.t(`faturamentos:nfStatus.${texto}`)}
        </span>
    }

    cancelarFaturamento = (id, lista_atendimentos, tipo_faturamento) => {
        const { t } = this.props;
        const MySwal = withReactContent(Swal);
        let string_atendimentos = lista_atendimentos.map(atendimento => atendimento.id).join(',');
        MySwal.fire({
            title: t('faturamentos:lista.cancel.title'),
            text: t('faturamentos:lista.cancel.text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('faturamentos:lista.cancel.confirm'),
            cancelButtonText: t('common:label.no')
        }).then((result) => {
            if (result.isConfirmed) {
                // Envia para API
                const updateFaturamento = {
                    cancelado: true,
                    atendimentos_cadastro: string_atendimentos,
                    tipo_faturamento: tipo_faturamento
                }

                api({
                    method: 'put',
                    url: '/faturamento/' + id + '/',
                    data: updateFaturamento,
                })
                .then(response => {
                    const MySwal = withReactContent(Swal);
            
                    this.setState({
                        loading: false,
                    });
            
                    MySwal.fire({
                        title: <p>{t('faturamentos:lista.cancel.success')}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then((result) => {
                        window.location.reload();
                    });             
                })
                .catch(error => {
                    let erro_msg = t('faturamentos:lista.errors.cancel');

                    if (error.response && error.response.status === 500) {
                        erro_msg = t('faturamentos:errors.server');
                    }
            
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    });
            
                    this.setState({
                        loading: false,
                    });
                });
            }
        });
    }

    renderRows = () => {   
        const { t } = this.props;
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id} title={item.cancelado ? t('faturamentos:lista.canceledRow') : ''}>
                <td>{item.id}</td>
                <td>{t('faturamentos:lista.period', {
                    inicio: item.data_inicio ? formataDataExibicao(item.data_inicio) : '---',
                    fim: item.data_fim ? formataDataExibicao(item.data_fim) : '---',
                })}</td>
                <td>
                    {item.pago ? t('common:label.yes') : t('common:label.no')}
                    {item.data_pagamento &&
                    <>
                        <br />
                        <small>{t('faturamentos:lista.paidOn', { data: formataDataHoraExibicao(item.data_pagamento) })}</small>
                    </>
                    }
                </td>
                <td>{(item.data_vencimento) ? formataDataExibicao(item.data_vencimento) : '--'}</td>
                <td>
                    {item.dados_laboratorio.nome}
                    <br />
                    <small>CNPJ: {formataCNPJ(item.dados_laboratorio.cpf_cnpj)}</small>
                </td>
                <td>{item.dados_programa.nome}</td>
                <td>{formatarMoeda(item.valor_total || 0)}</td>
                <td>
                    {item.cancelado ? this.getLabelNotaFiscal('cancelado', 'cancelado') : this.getLabelNotaFiscal(item.nota, item.nota_fiscal_status)}   
                </td>
                {this.state.tipo_usuario !== 'prestador' && (
                    <>
                    <td>{item.nota_comissao_numero ? item.nota_comissao_numero : '--'}</td>
                    <td>
                    {item.taxa_administrativa_valor && (
                        <>
                            {item.taxa_administrativa_valor 
                            ? parseFloat(item.taxa_administrativa_valor).toLocaleString(idiomaAtual(), { style: 'currency', currency: 'BRL' })
                            : ''}
                        &nbsp;({item.taxa_administrativa 
                            ? parseFloat(item.taxa_administrativa).toLocaleString(idiomaAtual())
                            : ''}%)
                        </>
                    )}
                    </td>
                    </>
                )}
                
                <td>
                    
                        <Button variant="light" href={"/faturamentos/edit/"+item.id} size="sm">
                            <FaRegEdit /> {t('faturamentos:lista.view')}
                        </Button>   
                    
                    {!item.cancelado && !item.pago && this.state.tipo_usuario !== 'prestador' && item.dados_programa.tipo_faturamento === 'servico' && (
                        <Button variant="danger" onClick={() => this.cancelarFaturamento(item.id, item.lista_atendimentos, item.dados_programa.tipo_faturamento)} size="sm">
                            {t('common:button.cancel')}
                        </Button>    
                    )} 
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={7}>{t('faturamentos:lista.empty')}</td>
            </tr>
        );
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.consultaRegistros();
        });
    };

    filtrarFaturamento = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.consultaRegistros()
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_programa_id: null,
            filtro_programa_nome: '',
            filtro_prestador_id: null,
            filtro_prestador_nome: '',
            filtro_pago: '',
            filtro_status_nf: '',
            filtro_numero_nf: '',
            filtro_servico_id: '',
            filtro_servico_nome: '',
            servico_select_key: this.state.servico_select_key + 1,
            page_numb: 1, // Reseta a paginação, se necessário
        }, () => {
            this.consultaRegistros(); // Chama a função para consultar registros com os filtros limpos
        });
    };

    render() {        
        if (!hasPerm('view_faturamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        const { t } = this.props;

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{t('faturamentos:lista.pageTitle')}</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>{t('faturamentos:lista.filtersTitle')}</h4>
                        <Form method="get" onSubmit={this.filtrarFaturamento}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.startDate')}</Form.Label>
                                        <Form.Control type="date" name="filtro_data_inicio" value={this.state.filtro_data_inicio} onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.endDate')}</Form.Label>
                                        <Form.Control type="date" name="filtro_data_fim" value={this.state.filtro_data_fim} onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')} />    
                                    </Form.Group>
                                </Col>
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={6} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.programs')}</Form.Label>
                                        <AsyncSelect           
                                            key={this.state.programa_id}                     
                                            cacheOptions
                                            loadOptions={this.carregaProgramasDelay} 
                                            defaultOptions                       
                                            onMenuOpen={() => this.carregaProgramas("")} 
                                            name="programa_id"
                                            placeholder={t('faturamentos:lista.filters.programPlaceholder')}
                                            noOptionsMessage={() => t('faturamentos:lista.filters.programEmpty')}
                                            isDisabled={this.state.ambiente_programa_id ? true : false}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.category')}</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="filtro_categoria_prestador" 
                                            value={this.state.filtro_categoria_prestador} 
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_categoria_prestador')}
                                        >
                                            <option value="">{t('faturamentos:lista.filters.all')}</option>
                                        {Object.entries(this.categoriasPrestador).map(([key, value]) => (
                                            <option key={key} value={key}>{t(`enums:categoriaPrestador.${key}`, { defaultValue: value })}</option>
                                        ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={8} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.provider')}</Form.Label>
                                        <AsyncSelect            
                                           key={this.state.filtro_programa_id}                     
                                            cacheOptions
                                            loadOptions={this.carregaPrestadoresDelay} 
                                            defaultOptions
                                            onMenuOpen={() => this.carregaPrestadores("")}
                                            name="prestador_id"
                                            placeholder={t('faturamentos:lista.filters.providerPlaceholder')}
                                            noOptionsMessage={() => t('faturamentos:lista.filters.noResults')}
                                            onChange={e => this.handleChangeFiltros(e, 'prestador_id')}
                                            value={this.state.filtro_prestador_id ? { value: this.state.filtro_prestador_id, label: this.state.filtro_prestador_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                </>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.paid')}</Form.Label>
                                        <Form.Control 
                                        as="select" 
                                        name="filtro_pago" 
                                        value={this.state.filtro_pago} 
                                        onChange={this.handleChangeFiltrosPagamento}
                                        >
                                        <option value="">{t('faturamentos:lista.filters.paymentStatus')}</option>
                                        <option value="true">{t('common:label.yes')}</option>
                                        <option value="false">{t('common:label.no')}</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.nfStatus')}</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filtro_status_nf"
                                            value={this.state.filtro_status_nf}
                                            onChange={this.handleChangeFiltrosPagamento}
                                        >
                                            <option value="">{t('faturamentos:lista.filters.nfStatusPlaceholder')}</option>
                                            <option value="analise">{t('faturamentos:lista.filters.nfAnalysis')}</option>
                                            <option value="aprovado">{t('faturamentos:nfStatus.aprovado')}</option>
                                            <option value="recusado">{t('faturamentos:nfStatus.recusado')}</option>
                                        </Form.Control>
                                        </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.billingId')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_id_faturamento"
                                            value={this.state.filtro_id_faturamento}
                                            onChange={this.handleChangeFiltrosPagamento}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            <Col sm={3} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('faturamentos:lista.filters.service')}</Form.Label>
                                    <AsyncSelect
                                        key={this.state.servico_select_key}
                                        cacheOptions
                                        defaultOptions
                                        isClearable
                                        loadOptions={this.carregaServicos}
                                        placeholder={t('faturamentos:lista.filters.allServices')}
                                        noOptionsMessage={() => t('faturamentos:lista.filters.servicesHint')}
                                        value={this.state.filtro_servico_id
                                            ? { value: this.state.filtro_servico_id, label: this.state.filtro_servico_nome }
                                            : null}
                                        onChange={(event) => this.setState({
                                            filtro_servico_id: event ? event.value : '',
                                            filtro_servico_nome: event ? event.label : '',
                                        })}
                                    />
                                </Form.Group>
                            </Col>
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={2} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.canceled')}</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="filtro_cancelado" 
                                            value={this.state.filtro_cancelado} 
                                            onChange={this.handleChangeFiltrosPagamento}
                                        >
                                            <option value="">{t('faturamentos:lista.filters.all')}</option>
                                            <option value="true">{t('common:label.yes')}</option>
                                            <option value="false">{t('common:label.no')}</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.tipo_usuario !== 'prestador' && (
                                <Col sm={2} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:lista.filters.nfNumber')}</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            name="filtro_numero_nf" 
                                            value={this.state.filtro_numero_nf} 
                                            onChange={this.handleChangeFiltros}
                                            placeholder={t('faturamentos:lista.filters.nfNumberPlaceholder')}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            
                            </Row>      
                            <Button type="submit" variant="secondary" size="sm">
                                <FaSearch /> {t('common:button.filter')}
                            </Button>
                            <Button type="button" variant="secondary" size="sm" onClick={() => this.limpaFiltro()}>
                                <FaEraser /> {t('faturamentos:lista.filters.clear')}
                            </Button>
                        </Form> 

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>{t('faturamentos:lista.columns.os')}</th>
                                    <th>{t('faturamentos:lista.columns.period')}</th>
                                    <th>{t('faturamentos:lista.columns.payment')}</th>
                                    <th>{t('faturamentos:lista.columns.dueDate')}</th>
                                    <th>{t('faturamentos:lista.columns.provider')}</th>
                                    <th>{t('faturamentos:lista.columns.program')}</th>
                                    <th>{t('faturamentos:lista.columns.total')}</th>
                                    <th>{t('faturamentos:lista.columns.invoice')}</th>
                                    {this.state.tipo_usuario !== 'prestador' && (
                                        <>
                                            <th>{t('faturamentos:lista.columns.commissionNote')}</th>
                                            <th>{t('faturamentos:lista.columns.adminFee')}</th>
                                        </>
                                    )}
                                    <th>{t('faturamentos:lista.columns.options')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>{t('common:label.loading')}</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{t(this.state.error)}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>

                
            </div>
        );
    }
}

Faturamentos.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation(['faturamentos', 'common', 'enums'])(withRouter(Faturamentos));